import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { UserRolesProvider } from '@ti/shared/roles/providers'

@NgModule({
  imports: [CommonModule],
  providers: [UserRolesProvider],
})
export class UserModule {}
